import { useCallback } from 'react';

import useAsyncRequest from '../../../hooks/useAsyncRequest';
import { getPortalId } from '../../api/organization';
import useSlug from '../../hooks/useSlug';

const useCurrentPortalId = () => {
  const slug = useSlug();
  const getPortalIdReq = useCallback(() => getPortalId(slug), [slug]);

  return useAsyncRequest(getPortalIdReq);
};

export default useCurrentPortalId;
